import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/image copy 3.png";
import emotion from "../../Assets/Projects/image copy 5.png";
import editor from "../../Assets/Projects/image copy 2.png";
import chatify from "../../Assets/Projects/image copy.png";
import suicide from "../../Assets/Projects/image copy 4.png";
import bitsOfCode from "../../Assets/Projects/image.png";


function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
        <Col md={4} className="project-card">
  <ProjectCard
    imgPath={editor}
    isBlog={false}
    title="Health Care"
    description="A dynamic and personalized health care website built with Next.js, React.js, and Node.js, with MySQL as the database. This platform features an online diet plan program, health reads, blogs, recipes, programs, and an integrated payment gateway. The blog content is editable via CKEditor, and various aspects are controlled through an intuitive dashboard."
    demoLink="https://www.balancenutrition.in/"
  />
</Col>


          <Col md={4} className="project-card">
  <ProjectCard
    imgPath={chatify}
    title="F Real Estate"
    description="Built with Next.js, React.js, Node.js, and MongoDB, F Real Estate is a platform under FashionTV’s real estate licensing. It offers seasoned professionals a collaborative opportunity to establish a significant presence in the real estate business. The stack ensures a dynamic and responsive user experience with robust backend support."
    ghLink=""
    demoLink="https://ftvrealestate.in/"
  />
</Col>


          <Col md={4} className="project-card">
          <ProjectCard
            imgPath={bitsOfCode}
            isBlog={false}
            title="FTV Top 100 Stylists"
            description="Built with Next.js and Bootstrap CSS, this project dynamically renders content from Markdown files using Next.js. The backend is powered by PHP with CodeIgniter, ensuring efficient data management and robust performance for a seamless user experience."
            ghLink=""
            demoLink="https://blogs.soumya-jit.tech/"
          />
        </Col>


         
                <Col md={4} className="project-card">
        <ProjectCard
          imgPath={leaf}
          isBlog={false}
          title="Jio Creative Lab"
          description="Built with Next.js and Bootstrap CSS, this project takes content from Markdown files and dynamically renders it using Next.js. It demonstrates a seamless integration of modern web technologies to create a responsive and efficient content management system."
          ghLink="https://github.com/helloakshay27/creative_page.git"
          demoLink="https://bit.ly/42z6H0Y"
        />
      </Col>


          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={suicide}
              isBlog={false}
              title="ERP System Dashboard - Ruby on Rails

              "
              description="The ERP System Dashboard is It centralizes all critical business processes, enabling efficient management and analysis of key enterprise data. Designed with scalability and flexibility in mind, this dashboard seamlessly integrates various modules such as finance, inventory, human resources, and customer relationship management (CRM).Using "
              // ghLink="https://github.com/soumyajit4419/AI_For_Social_Good"
              // demoLink="https://www.youtube.com/watch?v=dQw4w9WgXcQ&ab_channel=RickAstley" <--------Please include a demo link here
            />
          </Col>

          <Col md={4} className="project-card">
          <ProjectCard
            imgPath={emotion}
            isBlog={false}
            title="Taskmanagement WebApp"
            description="A comprehensive Task Management WebApp built with React.js and Node.js. This application features a drag-and-drop plugin for intuitive task organization, a detailed reporting system, and a Kanban board for visual project management. The seamless integration of these tools ensures efficient workflow and task tracking."

          />
        </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
